module.exports = __webpack_public_path__ + "static/img/nav7.32b01f7e.svg";